import { nav } from './section/nav'

export const en_US = {
    ...nav
};
